var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top 16px;\n  margin-bottom: 32px;\n"], ["\n  margin-top 16px;\n  margin-bottom: 32px;\n"])));
var ContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 12px;\n  width: 100%;\n  word-break: break-word;\n  white-space: pre-wrap;\n"], ["\n  font-size: 12px;\n  width: 100%;\n  word-break: break-word;\n  white-space: pre-wrap;\n"])));
var OfferListSummary = function (_a) {
    var content = _a.content, contributedToOkagesamaNoMori = _a.contributedToOkagesamaNoMori;
    var t = useTranslation().t;
    return (React.createElement(Wrapper, null,
        React.createElement(ContentWrapper, { dangerouslySetInnerHTML: { __html: content } }),
        contributedToOkagesamaNoMori && (React.createElement(Typography, { variant: "caption" }, t('labels.contributedToOkagesamaNoMori')))));
};
export default OfferListSummary;
var templateObject_1, templateObject_2;
